<template>
  <div class="name-item">
    <template v-if="!conversionName">
        <el-input  
          v-model="name" 
          :placeholder="showBtn?'无转化，请输入转化名称后点击创建按钮':'请选择跟踪类型和转化名称'"
          :disabled="isDisabled"
          @input="handleInput"
        />
        <div v-if="!firstLoading">
          <el-button 
            v-if="showBtn"
            type="primary" 
            class="ml8" 
            :loading="loading"  
            @click="()=>handleAddClick(name)"
          >
            创建
          </el-button>
        </div>
    </template>
    <template v-else>
      <el-input disabled :value="conversionName"  />
    </template>
    <div v-if="!!showErr" class="el-form-item__error">{{showErr}}</div>
  </div>
</template>

<script>
import API from '@/api/marketManage/miBatchAuto'
import { validEmoji } from '@/utils/validate'
export default {
  name: 'ConversionName',
  inject: [ 'getFormParams', 'getPackageType', 'getTypeNameData', 'getTypeData', 'getDeepTypeNameData' ],
  props: [ 'follType', 'convType', 'addType', 'appId' , 'isDeep', 'convTargetData'],
  data() {
    return {
      name: '',
      nameData: {},
      loading: false,
      firstLoading: false,
      showErr: ""
    }
  },
  computed: {
    convTarget() {
      return [...(this.convTargetData || [])].pop() || ''
    },
    isDisabled() {
      if (this.isDeep) {
        return  !this.follType|| this.conversionName|| this.firstLoading || !this.convTarget
      }else {
        return !this.follType || !this.convType.length || this.conversionName || this.firstLoading
      }
    },
    showBtn() {
      if (this.isDeep) {
        return !this.conversionName && this.follType && this.convTarget
      }else {
        return !this.conversionName && this.follType && this.convType.length
      }
      
    },
    nameId() {
      return this.nameData.conversion_id
    },
    conversionName() {
      return this.nameData.conversion_name
    },
    deepFormData() {
      const { follType,   convTarget } = this
      return {
        follType,
        convTarget
      }
    },
    formData() {
      const { follType,  convType} = this
      return {
        follType,
        convType,
      }
    }
  },
  watch: {
    deepFormData: {
      handler() {
        if (!this.convTarget) {
          return
        }
        this.firstLoading = true
        const { account_id, app_id } = this.getFormParams();
          const params = {
            account_id,
            app_id: this.appId || app_id,
            tracking_type: this.follType,
            conversion_type: this.convTarget,
            isDeep: this.isDeep,
            deep_conversion: '1'
          };
        this.getDeepTypeNameData((data = {})=> {
          this.firstLoading = false
          this.name = ''
          this.nameData = data;
        },params)
      },
      deep: true,
      immediate: true
    },
    formData: {
      handler() {
        const type = [...this.convType].pop();
         if (!type || !this.follType || this.isDeep) {
          return
        }
        this.firstLoading = true
        const { account_id, app_id } = this.getFormParams();
          const params = {
            account_id,
            app_id: this.appId || app_id,
            tracking_type: this.follType,
            conversion_type: type,
            isDeep: !this.isDeep,
          };
        this.getTypeNameData((data = {})=> {
          this.firstLoading = false
          this.name = ''
          this.nameData = data;
        },params)
      },
      deep: true,
      immediate: true
    },
    nameId(v) {
      this.$emit('input', v || '')
    }
  },
   mounted() {
    const fn = (...arg)=> {
      this.updateName(...arg)
    }
    this.$bus.$on('updateName', fn);
    this.$once('hook:beforeDestroy', () => {
         this.$bus.$off('updateName', fn)
    });
  },
  methods: {
    handleInput(value) {
      if (validEmoji(value)) {
        this.showErr = '不可输入表情'
      }else if(value.length>15){
        this.showErr = '不可超过15个字'
      }else {
        this.showErr = ''
      }
    },
    updateName(isAxjx = true,prams, data) {
       const type = this.isDeep ? this.convTarget : [...this.convType].pop();
      if (isAxjx) {
       
         if (!type || !this.follType) {
          return
        }
        const { account_id, app_id } = this.getFormParams();
          const params = {
            account_id,
            app_id: this.appId || app_id,
            tracking_type: this.follType,
            conversion_type: type
          }
        if (this.isDeep) {
          this.getDeepTypeNameData((data)=> {
            this.name = ''
            this.nameData =data;
          },params)
        }else {
          this.getTypeData(({ conversion_name })=> {
             console.log(conversion_name, 'getTypeData');
            this.name = ''
            this.nameData = { ...(conversion_name[0] || {}) };
          },params)
        }
      }else {
        const { app_id, tracking_type, conversion_type } = prams;
        const pData = this.getFormParams();
        if (
            app_id ===(this.appId || pData.app_id) && 
            tracking_type ===this.follType && 
            conversion_type ===type 
          ) {
          this.name = ''
          this.nameData = { ...data };
        }
      }
    },
    // 添加转化名称
    async handleAddClick(name) {
      if (!!this.showErr) {
        return;
      }
      this.loading = true;
      if (!this.follType||!this.convType.length) {
        this.$message.error('请选选择跟踪类型和转化类型')
        return;
      }
      const { app_id, account_id } = this.getFormParams()
      const params = {
        app_id: this.appId || app_id,
        account_id,
        package_type: this.getPackageType(),
        tracking_type: this.follType,
        conversion_type: this.isDeep ? this.convTarget : [...this.convType].pop(),
        name
      }
      try {
        const { data, info } = await API.addConversionData(params);
        this.$bus.$emit('updateName', false, params, data)
        this.$message.success(info)
      } catch (error) {
        this.$message.error(error.info || '创建失败')
      } finally {
         this.loading = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.name-item {
  display: flex;
}
</style>